import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';

export const useCampaignAnalyticsReactificationFeature = () => {
  return useFeatureFlag('CampaignAnalyticsReactification', false);
};
